import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {  Button, Modal, Signature } from '../components';
import ApplicationFullInformation from './ApplicationFullInformation';
import { useModal, useSelect, useAction } from '../hooks';
import { get } from 'lodash';

const ApplicationPreview = ({ onChange, value, onPrevious, isLoading, isPassed }) => {

  const signatureRef = useRef()
  const [isOpen, onOpen, onClose] = useModal()
  const [signType, setSignType] = useState(null)
  const selectedTransaction = useSelect('transaction.selected', { id: process.env.REACT_APP_DEFAULT_TRANSACTION })
  const serviceTypeGetList = useAction('serviceType.getList');
  const appTransaction = JSON.parse(localStorage.getItem('app_transaction')) || {}
  const selectedTransactionType = useSelect('transactionType.selected', { id: get(appTransaction, 'transaction_type_id') })
  const ownershipType = useSelect('ownershipType.selected', { id: get(appTransaction, 'ownership_type_id') })

  

  useEffect(() => {
    serviceTypeGetList()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onClear = e => {
    e.preventDefault()
    signatureRef.current.clear()
  }

  const handleAttach = e => {
    e.preventDefault()
    onChange({
      target: {
        name: `${signType}_url`,
        value: signatureRef.current.toDataURL()
      }
    })
    
    onClose()
  }

  const handleOpenModal = type => e => {
    e.preventDefault()
    setSignType(type)
    onOpen()
  }
  
  return (
    <>
      <b className="text-success font-medium">Transaction</b>
      <div className="grid grid-cols overflow-hidden gap-y-1">
        <ApplicationPreview.Item label="Transaction" value={get(selectedTransaction, 'attributes.name')}/>
        <ApplicationPreview.Item label="Transaction Type" value={get(selectedTransactionType, 'attributes.name')}/>
        <ApplicationPreview.Item label="Ownership Type" value={get(ownershipType, 'attributes.name')}/>
      </div>
      <br/>
      <ApplicationFullInformation value={value} />
      <div className="py-10">
        <div className="flex space-y-5 flex-col p-10">
          <p>
            &emsp;&emsp;&emsp;I,{' '} 
            {+get(appTransaction, 'ownership_type_id') === 1 && 
            <span className="border-b">
              {`${value.first_name || ''} ${value.middle_name || ''} ${value.last_name || ''} ${value.extension_name || ''}`}
            </span>}
            {[2,3,4].indexOf(+get(appTransaction, 'ownership_type_id')) > -1 &&
            <span className="border-b">
              {`${value.representative_first_name || ''} ${value.representative_middle_name || ''} ${value.representative_last_name || ''} ${value.representative_extension_name || ''}`}
            </span>}
            {' '}do hereby ATTEST that the foregoing
            information are complete, true and correct to the best of my knowledge and belief. I commit to inform the
            Board in writing any subsequent changes in this data sheet within 15 days from knowledge thereof.
          </p>
          {+get(appTransaction, 'ownership_type_id') === 1 && 
          <div className="flex flex-col w-auto justify-center self-center">
            <Button onClick={handleOpenModal('signature')} className="!bg-transparent !text-info !w-auto h-16">[ {value.signature_url ? 'Re-' : ''}Attach Signature ]</Button>
            {value.signature_url 
              ? <img className="h-32 w-64 m-auto" src={value.signature_url} alt="Client Signature" /> 
              : null
            }
            <p className="text-center">{`${value.first_name || ''} ${value.middle_name || ''} ${value.last_name || ''} ${value.extension_name || ''}`}</p>
            <p className="border-t text-center">Signature Over Printed Name</p>
          </div>}
          {[2,3,4].indexOf(+get(appTransaction, 'ownership_type_id')) > -1 &&  value.representative_first_name && value.representative_first_name !== '' &&
          <div className="flex flex-col w-auto justify-center self-center">
          <Button onClick={handleOpenModal('representative_signature')} className="!bg-transparent !text-info !w-auto h-16">[ {value.representative_signature_url ? 'Re-' : ''}Attach Signature ]</Button>
            {value.representative_signature_url 
              ? <img className="h-32 w-64 m-auto" src={value.representative_signature_url} alt="Client Signature" /> 
              : null
            }
            <p className="text-center">{`${value.representative_first_name || ''} ${value.representative_middle_name || ''} ${value.representative_last_name || ''} ${value.representative_extension_name || ''}`}</p>
            <p className="border-t text-center">Signature Over Printed Name</p>
            <p className="text-center">Representative</p>
          </div>}
        </div>
      </div>
      <div className="flex space-x-2 float-right">
        <Button type="button" onClick={onPrevious(value)} className="!bg-warning !w-auto !text-black">Previous</Button>
        <Button isLoading={isLoading} disabled={!isPassed}  className="!w-auto">Proceed</Button>
      </div>
      <Modal isOpen={isOpen} onClose={onClose}>
        <b className="font-medium text-primary">{(signType || '').replace('_', ' ').toUpperCase()}</b>
        <div className="w-full h-64 p-5">
          <Signature ref={signatureRef} />
        </div>
        <div className="flex space-x-2 px-5">
          <Button onClick={onClear} type="button" className="!bg-gray-300 !text-primary">Clear</Button>
          <Button onClick={handleAttach} type="button">Attach</Button>
        </div>
      </Modal>
    </>

  )
}

ApplicationPreview.Item = ({ label, value, className }) => {
  return (
    <div className={`flex flex-col xl:flex-row lg:flex-row space-x-0 xl:space-x-2 lg:space-x-2 items-start xl:items-center lg:items-center ${className}`}>
      <span className="w-auto xl:w-64 lg:w-48 text-sm text-gray-600">{label} <b className="float-right">:</b></span>
      <span className="font-medium text-sm">{value}</span>
    </div>
  )
}


ApplicationPreview.propTypes = {
  value: PropTypes.shape({
    signature_url: PropTypes.string,
    representative_signature_url: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.instanceOf(Function).isRequired,
  onNext: PropTypes.instanceOf(Function).isRequired,
  onPrevious: PropTypes.instanceOf(Function).isRequired,
  isPassed: PropTypes.bool.isRequired
}

ApplicationPreview.displayName = 'ApplicationPreview'

export default ApplicationPreview